<template>
  <div
    class="e2e-gfx3d-form card container"
    style="padding: 10px 10px 10px 10px; min-width: 100%; margin: 15px 0px 15px 0px;"
  >
    <div v-if="filteredPoints.length === 0">Keine Punkte vorhanden</div>

    <div v-for="point in filteredPoints" :key="point.name" class="row">
      <label class="col-sm-3 col-form-label-sm">
        Punkt:
        <b>{{point.name}}</b>
      </label>

      <div class="col-sm-3">
        <div class="input-group input-group-sm">
          <div class="input-group-prepend">
            <span class="input-group-text">X</span>
          </div>
          <input
            class="form-control"
            v-mc-validate="{ expect: 'real', allowNoValue: false }"
            v-model="point.x.strValue"
          >
        </div>
      </div>

      <div class="col-sm-3">
        <div class="input-group input-group-sm">
          <div class="input-group-prepend">
            <span class="input-group-text">Y</span>
          </div>
          <input
            class="form-control"
            v-mc-validate="{ expect: 'real', allowNoValue: false }"
            v-model="point.y.strValue"
          >
        </div>
      </div>

      <div class="col-sm-3">
        <div class="input-group input-group-sm">
          <div class="input-group-prepend">
            <span class="input-group-text">Z</span>
          </div>
          <input
            class="form-control"
            v-mc-validate="{ expect: 'real', allowNoValue: false }"
            v-model="point.z.strValue"
          >
        </div>
      </div>
    </div>
    <div>
      <button
        class="btn btn-primary float-right"
        @click="onUpdateBoard"
      >{{fragment.changeButtonText}}</button>
    </div>
  </div>
</template>

<script>
import "../../utils.js"; // v-mc-validate directive
import { onUpdateForms, updateData, updateBoard, updateForms } from "./gfx3d";

export default {
  name: "fragment-gfx3d-form",
  props: ["fragment"],
  data() {
    return {
      points: []
    };
  },
  methods: {
    onUpdateBoard() {
      updateData({ points: this.points });
      updateBoard();
      updateForms(); // other forms?
    }
  },
  computed: {
    filteredPoints() {
      return this.points.filter(p =>
        this.fragment.visiblePoints.includes(p.name)
      );
    }
  },
  mounted() {
    const that = this;
    onUpdateForms(
      data => (that.points = JSON.parse(JSON.stringify(data.points)))
    );
    updateForms(); // force initial update
  }
};
</script>
 

<style scoped>
</style>